import styles from "./Image.module.css";
import img from "../../assets/images/logo192.png";
import React from "react";

export const ImageIllustration = ({ src, alt = null, openImage = false, baseUrl = process.env.REACT_APP_API_URL_PUBLIC }) => {
    // if src starts with baseUrl then remove it
    if (src && !src.startsWith(baseUrl)) {
       src = baseUrl + src;
    }
    return (
        <div className={`skeleton ${styles.illustrationContainer}`}>
            {src ? (
                openImage ? (
                    <a href={src} rel="noopener noreferrer" target="_blank">
                        <img src={src} alt={alt} className={styles.illustration} loading="lazy" />
                    </a>
                ) : (
                    <img src={src} alt={alt} className={styles.illustration} loading="lazy" />
                )
            ) : (
                <p style={{ margin: "10px", textAlign: "center", fontStyle: "italic", fontWeight: "300", fontSize: "0.9rem" }}>
                    Pas d'image
                </p>
            )}
        </div>
    );
};